import React, { useRef } from "react";
import { useSelector } from "react-redux";
import styled from "styled-components";
import classnames from "classnames";
import { intersection } from "lodash";

import { SIDEPANEL_WIDTH } from "../../utils";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";

import ProgramSurveyMetrics from "../../sections/program/SurveyMetrics";
import ProgramGeneralMetrics from "../../sections/program/GeneralMetrics";
import UaBas from "../../sections/program/UaBas";
import ClientCount from "../../sections/program/ClientCount";
import Education from "../../sections/program/Education";
import Employment from "../../sections/program/Employment";
import MeetingsCheckins from "../../sections/program/MeetingsCheckins";
import Referrals from "../../sections/program/Referrals";
import DaysSober from "../../sections/program/DaysSober";
import SubstancesOfChoice from "../../sections/program/SubstancesOfChoice";
import ProgramLength from "../../sections/program/ProgramLength";
import ReasonForDischarge from "../../sections/program/ReasonForDischarge";
import PostGeneralMetrics from "../../sections/program/PostGeneralMetrics";

import PostProgramGeneralMetrics from "../../sections/post_program/GeneralMetrics";

import SearchBar from "../SearchBar";
import MedicalMetrics from "../../sections/program/MedicalMetrics";
import DemographicMetrics from "../../sections/program/DemographicsMetrics";
import { useReactToPrint } from "react-to-print";
import PublicBenefits from "../../sections/program/PublicBenefits";
import ProgramHistory from "../../sections/program/ProgramHistory";
import CriminalHistory from "../../sections/program/CriminalHistory";
import MedicinalMarijuana from "../../sections/program/MedicinalMarijuana";

export default function index(props) {
  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });
  const {
    group_ids,
    group_categories,
    groups,
    all_resident_statuses,
    resident_statuses,
    all_group_categories,
    permissions,
    organization_name,
  } = props;
  const { services } = props.permissions;
  const { showSidePanel } = useSelector((state) => state.config);
  const { selected } = useSelector((state) => state);
  return (
    <Container
      className={classnames("bg-white h-100 border-right border-bottom", {
        "border-left": !showSidePanel,
      })}
      style={{
        width: showSidePanel ? `calc(100% - ${SIDEPANEL_WIDTH})` : "100%",
      }}
    >
      <div className="border-bottom border-top">
        <div
          className="text-center pt-2 text-capitalize"
          style={{ fontWeight: "500" }}
        >
          {selected.name}
        </div>
        <div className="d-flex align-items-center justify-content-between w-100">
          <SearchBar
            group_ids={group_ids}
            groups={groups}
            handlePrint={handlePrint}
            group_categories={group_categories}
            all_group_categories={all_group_categories}
            resident_statuses={resident_statuses}
            all_resident_statuses={all_resident_statuses}
            organization_name={organization_name}
          />
        </div>
      </div>
      <div
        className="d-flex p-3 flex-column pb-5"
        style={{
          height: "calc(100% - 150px)",
          overflowY: "scroll",
          backgroundColor: "rgba(0,0,0,0.03)",
        }}
        ref={componentRef}
      >
        <Routes>
          <Route
            exact
            path="/organizations/:organization_name/outcomes"
            element={<ProgramGeneralMetrics {...props} />}
          />
          <Route
            path="/organizations/:organization_name/outcomes/client_count"
            element={<ClientCount {...props} />}
          />
          <Route
            path="/organizations/:organization_name/outcomes/demographics"
            element={<DemographicMetrics {...props} />}
          />
          {!permissions.is_only_treatment_center && (
            <Route
              path="/organizations/:organization_name/outcomes/education"
              element={<Education {...props} />}
            />
          )}
          {!permissions.is_only_treatment_center && (
            <Route
              path="/organizations/:organization_name/outcomes/employment"
              element={<Employment {...props} />}
            />
          )}
          {!permissions.is_only_treatment_center &&
            intersection(services, ["medical_logs"]).length > 0 && (
              <Route
                path="/organizations/:organization_name/outcomes/medical"
                element={<MedicalMetrics {...props} />}
              />
            )}
          <Route
            path="/organizations/:organization_name/outcomes/meetings_checkins"
            element={<MeetingsCheckins {...props} />}
          />
          {!permissions.is_only_treatment_center && (
            <Route
              path="/organizations/:organization_name/outcomes/program_length"
              element={<ProgramLength {...props} />}
            />
          )}
          {!permissions.is_only_treatment_center && (
            <Route
              path="/organizations/:organization_name/outcomes/reasons_for_discharge"
              element={<ReasonForDischarge {...props} />}
            />
          )}
          {!permissions.is_only_treatment_center && (
            <Route
              path="/organizations/:organization_name/outcomes/medicinal_marijuana"
              element={<MedicinalMarijuana {...props} />}
            />
          )}
          {(!permissions.is_only_treatment_center ||
            permissions.has_crm_service) &&
            intersection(services, ["crm"]).length > 0 && (
              <Route
                path="/organizations/:organization_name/outcomes/referrals"
                element={<Referrals {...props} />}
              />
            )}
          {!permissions.is_only_treatment_center && (
            <Route
              path="/organizations/:organization_name/outcomes/days_sober"
              element={<DaysSober {...props} />}
            />
          )}
          {!permissions.is_only_treatment_center && (
            <Route
              path="/organizations/:organization_name/outcomes/substances_of_choice"
              element={<SubstancesOfChoice {...props} />}
            />
          )}
          {permissions.surveys.visible && (
            <Route
              path="/organizations/:organization_name/outcomes/surveys"
              element={<ProgramSurveyMetrics {...props} />}
            />
          )}
          {!permissions.is_only_treatment_center && (
            <Route
              path="/organizations/:organization_name/outcomes/ua_ba"
              element={<UaBas {...props} />}
            />
          )}
          <Route
            exact
            path="/organizations/:organization_name/outcomes/post"
            element={<PostGeneralMetrics {...props} />}
          />
        </Routes>
      </div>
    </Container>
  );
}

const Container = styled.div`
  width: calc(100% - ${SIDEPANEL_WIDTH});
  @media (max-width: 990px) {
    width: 100% !important;
    border-left: 1px solid rgb(207, 216, 220);
  }
`;
